<template>
  <div>
    <LandingHeader/>
    <main>
      <slot></slot>
    </main>
    <Footer/>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import LandingHeader from '@/components/landing/LandingHeader.vue';

export default {
  name: 'LandingLayout',
  components: { LandingHeader, Footer },
};
</script>

<style
  lang="scss"
  scoped
>

main {
  margin-top: 72px;
}
</style>
